/**
 * Factory for the anonymous, no-auth cloneai API client.
 *
 * The agent-runtime SPA (and any future unauthenticated surface) constructs
 * a `PublicApiClient` at boot. By contract — enforced at the type level with
 * `Omit<HttpClientOptions, 'getIdToken' | 'getAccessToken'>` — this factory
 * cannot be given any token provider, so no request it makes can ever carry
 * an `Authorization` (or `X-Cognito-Access-Token`) header. This is the
 * "no header leakage" guarantee P2-13 requires: the public client is a
 * separate object with a strictly narrower options type, not a flag on the
 * existing `ApiClient`.
 */
import { createHttpClient } from './http.js';
import { createPublicAgentsResource } from './resources/publicAgents.js';
import { createPublicSessionsResource, } from './resources/publicSessions.js';
export function createPublicApiClient(options) {
    // Intentionally does NOT accept `getIdToken` or `getAccessToken`. Passing
    // options through directly means createHttpClient receives no token
    // providers and has nothing to call. Combined with the `anonymous: true`
    // flag on every request in PublicAgentsResource, this makes an auth
    // header impossible by construction.
    const http = createHttpClient(options);
    return {
        http,
        publicAgents: createPublicAgentsResource(http),
        publicSessions: createPublicSessionsResource(http),
    };
}
//# sourceMappingURL=publicClient.js.map